
import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Network, Award } from 'lucide-react';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      icon: Shield,
      title: 'Security Training',
      description: 'Comprehensive cybersecurity courses for all skill levels',
      badge: false,
      link: '/training'
    },
    {
      icon: Award,
      title: 'Certifications',
      description: 'Industry-recognized credentials that boost your career',
      badge: true,
      link: '/training'
    },
    {
      icon: Network,
      title: 'Security Assessments',
      description: 'Professional evaluation of your security posture',
      badge: false,
      link: '/assessments'
    },
    {
      icon: Lock,
      title: 'Compliance Support',
      description: 'Expert guidance for regulatory requirements',
      badge: false,
      link: '/services'
    }
  ];

  return (
    <section className="py-12 md:py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10 md:mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4">
            <span className="bg-gradient-to-r from-[#422680] via-[#660F56] to-[#F54952] bg-clip-text text-transparent">
              Our Services
            </span>
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            End-to-end cybersecurity solutions tailored to your needs
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Link key={index} to={service.link} className="block">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="relative bg-white p-6 md:p-8 rounded-xl md:rounded-2xl border-2 border-gray-100 hover:border-[#422680] hover:shadow-2xl transition-all group h-full"
                >
                  {service.badge && (
                    <div className="absolute -top-3 right-6 bg-[#F54952] text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full">
                      Most Popular
                    </div>
                  )}
                  <motion.div
                    animate={{ 
                      rotate: [0, 360],
                      scale: [1, 1.1, 1]
                    }}
                    transition={{ 
                      duration: 3,
                      repeat: Infinity,
                      ease: "easeInOut"
                    }}
                    className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-[#422680] via-[#660F56] to-[#F54952] rounded-xl flex items-center justify-center mb-4 md:mb-6"
                  >
                    <Icon className="text-white" size={24} />
                  </motion.div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{service.title}</h3>
                  <p className="text-sm md:text-base text-gray-600">{service.description}</p>
                </motion.div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
